module.exports = __webpack_public_path__ + "static/images/chevron-up._36X8C7.svg";